"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/heineken-2021/heineken-2021.scss');
const index_1 = require("./../js/index");
const heineken_2021_1 = require("./../js/Sites/heineken-2021");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize Mattsson specific scripts
(0, heineken_2021_1.InitHeineken2021)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
